/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useMemo, useState, useEffect } from 'react';
import { DataTable } from './DataTable';
import { useHistory } from 'react-router';
import { getDetailSurveyResponse, getSurveyById } from '../../services/survey.service';
import { setSurveyResponse } from '../../redux/action/surveyAction';
import { useDispatch } from 'react-redux';
import { useUserInfo } from '../../providers/userProvider';
import { SCBM_CODE, NO_CONTACTS, SCBM_INDIRECT, CRS_REQUEST_STATUS_OBJ, CRS_SURVEY_CODES, SCBM_STATES_CAMPAIGN , DAYS_OF_THE_WEEK, CRS_SURVEY_TEMPLATES, DETAILS_PAGE_TABLE_HEADERS, EWDC, EMP_REQ, EMP_DEC, SEND_EMAIL, EMAIL_NOTIFICATION_SENT, SEND_EMAIL_FAILURE , REOPEN_REQUEST, REOPEN_FAILURE, REOPEN_SUCCESS, UNLOCK_REQUEST, UNLOCK_FAILURE, UNLOCK_SUCCESS} from '../../utils/surveyLiterals';
import { updateGenResponse } from '../../redux/action/genericSurveyAction';
import { setCampaign } from '../../redux/action/campaignAction';
import { getCampaigsByRn, deleteAssignment, getCampaignContacts, getNonDeereContactData, getSupplierContacts, updateLockedAssignment, updateAssignmentStatus } from '../../services/campaign.service';
import { Popover, OverlayTrigger, Button, Card, Alert, Form, Col } from '@deere/ux.uxframe-react';
import { SVGIcon, SVGIconDelete } from '../SVGIcon';
import { ModalGeneric } from '../ModalGeneric';
import { useTranslation } from "react-i18next";
import { PartPopUp } from '../conflict-mineral/PartPopUp';
import { getAllPartsRequestedByAssignment , removeRequestedPartFromAssignment } from '../../services/cm.service';
import { ReactComponent as AddIcon } from "@deere/ux.brand-foundations/icons/add_circle.svg";
import ModalContactUpdate from "./ModalContactUpdate";
import ModalAttachments from "./ModalAttachments";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { getRequestStatusWhenCampaignClosed } from '../../utils/utils';
import {  Accordion, AccordionItem, AccordionTitle, AccordionSummary, AccordionDetails, Tooltip, IconButton } from "@deere/fuel-react";
import { sendEmailNotification } from '../../services/campaign.service';
import SendIcon from '@mui/icons-material/Send';
import UndoIcon from '@mui/icons-material/Undo';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { useOktaAuth } from '@okta/okta-react';
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { Grid } from '@mui/material';

export default function TableCard({ campaignRes, accessToken, campaign, loadCampaing, additionalColumns }) {
    const userInfo = useUserInfo();
    const { authState } = useOktaAuth();
    const history = useHistory()
    const dispatch = useDispatch()
    const [reqStatus, setReqStatus] = useState();
    const [showError, setShowError] = useState(false);

    const [rnSelected, setRnSelected] = useState(undefined);
    const [showDeleteParts, setShowDeleteParts] = useState(true);
    const data = [...removeResponseOn(campaignRes)];
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success"); 


    const [showModal, setShowModal] = useState(false);
    const [showReopenModal, setShowReopenModal] = useState(false);
    const [showUnlockModal, setShowUnlockModal] = useState(false);
    const [assignId, setAssignId] = useState();
    const { t } = useTranslation();
    const [showParts, setShowParts] = useState(false);

    const [showContactUpdateModal, setShowContactUpdateModal] = useState(false);
    const [contactUpdateRow, setContactUpdateRow] = useState(null);
    const [showAttachmentModal, setShowAttachmentModal] = useState(false);
    const [selectedAttachmentRow, setSelectedAttachmentRow] = useState(null);
    const [popoverContacts, setPopoverContacts] = useState({});

    useEffect(() => {
        if(campaign.isNonDeere) return;
        const rows = Array.isArray(campaignRes) ? campaignRes : [];
        rows.forEach((row) => {
            const key = row.assignmentid;
            const supplierNumber = row.supplierNumber;
            const contacts = row.supplierContactName;
            if(!key || !supplierNumber || !Array.isArray(contacts) || contacts.length <= 1) return;
            getSupplierContacts(supplierNumber, campaign.id, accessToken)
                .then((res) => {
                    const enriched = (res || []).map((contact) => {
                        const id = (contact.contactUserId && contact.contactUserId.trim()) || contact.contactUID || "";
                        const name = [contact.firstName, contact.lastName].filter((p) => p && p.trim() !== "").join(" ").trim();
                        const roles = Array.isArray(contact.businessRoles) ? contact.businessRoles.map((role) => role.roleName).filter((n, i, arr) => n && n.trim() !== "" && arr.indexOf(n) === i).join(", ") : "";
                        return { id, name, roles };
                    });
                    setPopoverContacts((prev) => ({ ...prev, [key]: enriched }));
                })
                .catch((err) => console.log(err));
        });
    }, [campaignRes, campaign.id, campaign.isNonDeere, accessToken]);
    const handleLinkClick = useMemo(() => (e,cell) => {
        try {
            if (cell) {
                const supplierNumber = cell.row.original.supplierNumber
                const responseByName = cell.row.original.responseByName
                const supplierName = cell.row.original.supplierName

                if (campaign.templateType === CRS_SURVEY_TEMPLATES.PART) {
                    history.push({
                        pathname: `/surveypart?rn=${cell.value}`,
                        state: {
                            previous: '/details'
                        }
                    })
                    return;
                } else {
                    switch (campaign.surveyCode) {
                        case CRS_SURVEY_CODES.CM:
                            history.push({
                                pathname: `/cm?rn=${cell.value}`,
                                state: {
                                    previous: '/details'
                                }
                            })
                            return;
                        case CRS_SURVEY_CODES.EM:
                            history.push({
                                pathname: `/em?rn=${cell.value}`,
                                state: {
                                    previous: '/details'
                                }
                            })
                            return;
                        case CRS_SURVEY_CODES.TPS:
                        case CRS_SURVEY_CODES.TPSMEX:
                            history.push({
                                pathname: `/tps?rn=${cell.value}`,
                                state: {
                                    previous: '/details'
                                }
                            })
                            return;
                        case CRS_SURVEY_CODES.COO:
                            history.push({
                                pathname: `/coo?rn=${cell.value}`,
                                state: {
                                    previous: '/details'
                                }
                            })
                            return;
                        default:
                            break;
                    }
                }

                e.preventDefault();
                getDetailSurveyResponse(campaign.id, supplierNumber, accessToken)
                    .then((res) => {
                        if (res) {
                            campaign.surveyCode === SCBM_CODE || campaign.surveyCode === SCBM_INDIRECT ? dispatch(setSurveyResponse(res)) : dispatch(updateGenResponse({ surveyCode: campaign.surveyCode, surveyResponse: res }))
                        };
                    }).catch(error => {
                        console.log(error);
                    })

                getCampaigsByRn(cell.value, accessToken)
                    .then((res) => {
                        dispatch(setCampaign(res));
                    }).catch(error => {
                        console.log(error);
                    })

                getSurveyById(campaign.surveyId, accessToken)
                    .then((survey) => {
                        history.push({
                            pathname: campaign.surveyCode === CRS_SURVEY_CODES.ST ? '/streview' : '/review',
                            state: {
                                previous: '/details',
                                survey: survey,
                                updatedByName: responseByName !== undefined || responseByName !== null ? responseByName : '',
                                supplierName: supplierName !== undefined || supplierName !== null ? supplierName : '',
                                surveyType: survey.description,
                                campaign: campaign,
                                rn : cell.row.original.assignmentid,
                                endDate: campaign.endDate,
                                status: cell.row.original.status,
                                updatedTs: cell.row.original.responseon,
                            }
                        })
                    }).catch(err => { throw err })
            }
        } catch (err) {
            throw err
        }
    }, [accessToken, campaign.id, campaign.surveyCode, campaign.surveyId, dispatch, history])

    const sendEmailHandler =(cell, deereSupplierContacts, nonDeereSupplierContacts) => {   
        const assignmentId = cell.row.original.assignmentid.toString(); 
        const supplierNumber = cell.row.original.supplierNumber;
        const supplierName = cell.row.original.supplierName;
        const deereContacts = cell?.row?.original?.deereContactName??[];
        const companyContacts = cell?.row?.original?.companyContactName??[];
        sendEmailNotification(campaign.id, assignmentId, supplierNumber, supplierName, deereContacts, companyContacts,  deereSupplierContacts, nonDeereSupplierContacts, authState.accessToken.accessToken)
            .then((response) => {
                let statusMessage = "";
                let isFailure = false;
                if (Array.isArray(response?.status)) {
                    const statusValue = response.status[0];
                    statusMessage = statusValue || "";
                    isFailure = statusValue?.includes("Failed") || false;
                }
                setSnackbarMessage(statusMessage || response?.message || SEND_EMAIL_FAILURE);
                setSnackbarSeverity(isFailure ? "error" : "success");
                setOpenSnackbar(true);
            })
            .catch((error) => {
                console.error(SEND_EMAIL_FAILURE, error);
                setSnackbarMessage(SEND_EMAIL_FAILURE);
                setSnackbarSeverity("error");
                setOpenSnackbar(true);
            });
    }
    const sendNotifyEmail =(cell) => {
        const deereSupplierContacts = cell?.row?.values?.supplierContactName??[];
        const nonDeereSupplierContacts = cell?.row?.original?.nonDeereSupplierContactsIds??[];
        const isDisabled =
        (!campaign.isNonDeere && deereSupplierContacts.length === 0) || 
        (campaign.isNonDeere && nonDeereSupplierContacts.length === 0) || 
        cell.row.values.status === CRS_REQUEST_STATUS_OBJ.COMPLETE;
        return (
            <Tooltip title={SEND_EMAIL}>
                <IconButton 
                    disabled={isDisabled} 
                    variant="secondary" 
                    size="sm" 
                    onClick={() => sendEmailHandler(cell, deereSupplierContacts, nonDeereSupplierContacts)
                    }>
                    <SendIcon />
                </IconButton>
            </Tooltip>
        )
    }

    const reopeningAssignment = () => {   
        const assignmentId = assignId

        const request = {
            id: assignmentId,
            status: CRS_REQUEST_STATUS_OBJ.IN_PROCESS,
            updatedBy: userInfo.userID,
        }
        
        updateAssignmentStatus(request, authState.accessToken.accessToken)
            .then((response) => {
                if(response){
                    setSnackbarMessage(REOPEN_SUCCESS);
                    setSnackbarSeverity("success");
                }else{
                    setSnackbarMessage(REOPEN_FAILURE);
                    setSnackbarSeverity("error");
                }                
                setOpenSnackbar(true);
            })
            .catch((error) => {
                console.error(REOPEN_FAILURE, error);
                setSnackbarMessage(REOPEN_FAILURE);
                setSnackbarSeverity("error");
                setOpenSnackbar(true);
            });
    }

    const handleReopenAssignment = (cell) => {
        setAssignId(cell.row.original.id);
        setShowReopenModal(true);
    };

    const reopenAssignment =(cell) => {
        const isDisabled = cell.row.values.status !== CRS_REQUEST_STATUS_OBJ.COMPLETE;
        return (
            <Tooltip title={REOPEN_REQUEST}>
                <IconButton 
                    disabled={isDisabled} 
                    variant="secondary" 
                    size="sm" 
                    onClick={() => handleReopenAssignment(cell)
                    }>
                    <UndoIcon />
                </IconButton>
            </Tooltip>
        )
    }

    const unlockingAssignment = () => {   
        const assignmentId = assignId

        const request = {
            id: assignmentId,
            status: CRS_REQUEST_STATUS_OBJ.IN_PROGRESS,
            updatedBy: userInfo.userId,
        }
        //TODO: Uncomment the below code when the unlock assignment API is ready
        // updateLockedAssignment(request, authState.accessToken.accessToken)
        //     .then((response) => {
                // if(response){
                //     setSnackbarMessage(UNLOCK_SUCCESS);
                //     setSnackbarSeverity("success");
                // }else{
                //     setSnackbarMessage(UNLOCK_FAILURE);
                //     setSnackbarSeverity("error");
                // }                
                // setOpenSnackbar(true);
        //     })
        //     .catch((error) => {
        //         console.error(UNLOCK_FAILURE, error);
        //         setSnackbarMessage(UNLOCK_FAILURE);
        //         setSnackbarSeverity("error");
        //         setOpenSnackbar(true);
        //     });
    }

    const handleUnlockAssignment = (cell) => {
        setAssignId(cell.row.original.id);
        setShowUnlockModal(true);
    };

    const unlockAssignment =(cell) => {
        const isDisabled = cell.row.values.status !== CRS_REQUEST_STATUS_OBJ.COMPLETE;
        return (
            <Tooltip title={UNLOCK_REQUEST}>
                <IconButton 
                    disabled={isDisabled} 
                    variant="secondary" 
                    size="sm" 
                    onClick={() => handleUnlockAssignment(cell)
                    }>
                    <LockOpenIcon />
                </IconButton>
            </Tooltip>
        )
    }

    const popOverContacts = (cell, hideButton) => {
        if (!Array.isArray(cell.value)) { 
            return  <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                        <span>{NO_CONTACTS}</span>
                        {!hideButton &&
                        <Button variant="uxf-icon" className="btn-uxf-icon-no-hover" onClick={()=>{addContactHandler(cell)}} style={{marginLeft: "0px"}}>
                            <AddIcon />
                        </Button>}
                    </div> ;
        }

        if (cell.value.length === 0) {
            return  <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                        <span>{NO_CONTACTS}</span>
                        {!hideButton &&
                        <Button variant="uxf-icon" className="btn-uxf-icon-no-hover" onClick={()=>{addContactHandler(cell)}} style={{marginLeft: "0px"}}>
                            <AddIcon />
                        </Button>}
                    </div> ;
        }

        if (cell.value.length === 1) {
            return  <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                        <span>{cell.value}</span>
                        {!hideButton &&
                        <Button variant="uxf-icon" className="btn-uxf-icon-no-hover" onClick={()=>{addContactHandler(cell)}} style={{marginLeft: "0px"}}>
                            <AddIcon />
                        </Button>
        }
                    </div> ;
        }

        return <div className="uxf-popover-title" style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
            <span>{cell.value[0]?cell.value[0]: cell.value[1]}</span>
            <div style={{display: "flex", flexDirection: "column"}}>
                <OverlayTrigger placement="bottom" trigger="click" rootClose overlay={
                    <Popover id="popover-example">
                        <Popover.Content>
                            <Grid container direction="column" spacing={1}>
                                {
                                    cell.value.map((item, indx) => {
                                    const list = popoverContacts[cell.row.original.assignmentid];
                                    const enriched = list ? list.find((c) => c.id && item.includes(c.id)) : null;
                                    return (
                                        <Grid item key = {indx}>
                                            {enriched && enriched.name ? (
                                                <>
                                                    <div style = {{fontWeight: 600}}>{`${enriched.id} - ${enriched.name}`}</div>
                                                    {enriched.roles ? <div style = {{ fontSize: "smaller", color: "#6c757d" }}>{enriched.roles}</div> : null}
                                                </>
                                            ) : item}
                                        </Grid>
                                    );
                                })
                                }
                            </Grid>        
                        </Popover.Content>
                    </Popover>}>
                    <Button variant="uxf-icon" className="btn-uxf-icon-no-hover">
                        <SVGIcon />
                    </Button>
                </OverlayTrigger>
                {!hideButton &&
                <Button variant="uxf-icon" className="btn-uxf-icon-no-hover" onClick={()=>{addContactHandler(cell)}} style={{marginLeft: "0px"}}>
                    <AddIcon />
                </Button>
    }
            </div>
        </div>
    }

    const addContactHandler = (cell) => {
        if(!campaign.isNonDeere){
            getCampaignContacts(cell.row.original.assignmentid, accessToken).then((res) => {
                setContactUpdateRow({ toUpdate: cell.column.id, data: res, assignmentId: cell.row.original.assignmentid, rowData: cell.row.original });
                setShowContactUpdateModal(true);
            })
        }else{
            getNonDeereContactData(cell.row.original.assignmentid, accessToken).then((res) => {
                setContactUpdateRow({ toUpdate: cell.column.id, data: res, assignmentId: cell.row.original.assignmentid, rowData: cell.row.original });
                setShowContactUpdateModal(true);
            })
        }
    }

    const popUpPartsLink = (cell) => {
        return <a href='#' onClick={e => {
            e.preventDefault();
            setRnSelected(cell.row.values.id);
            if (cell.row.values.status === CRS_REQUEST_STATUS_OBJ.COMPLETE) {
                setShowDeleteParts(false)
            }
            else {
                setShowDeleteParts(true)
            }
            setShowParts(true);
        }
        } >{cell.value}</a>
    }

    const handledDelete = (cell) => {        
        setAssignId(cell.value);
        const req = cell.data.find(dat => dat.id === cell.value);
        setReqStatus(req.status);
        setShowModal(true);
    };

    const handleSubmit = async () => {
        const deleteResponse = await deleteAssignment(assignId, accessToken);
        if (deleteResponse) {
            if (deleteResponse.numberAssignmentsDeleted &&
                deleteResponse.numberAssignmentsDeleted === 1) {
                setShowModal(false);
                campaign.noAssignments = campaign.noAssignments - 1;
                if (reqStatus === CRS_REQUEST_STATUS_OBJ.COMPLETE) {
                    campaign.noSubmitted = campaign.noSubmitted - 1;
                }

                history.push({
                    pathname: '/details',
                    state: { campaign: campaign, previous: '/' }
                });
                window.location.reload(false);
            } else {
                setShowModal(false);
                setShowError(false);
                window.location.reload(false);
            }
        } else {
            setShowModal(false);
            setShowError(true);
        }
    };

    const iconDelete = (cell) => {
        return <div align="center">
            <a href='#' onClick={e => {
                e.preventDefault();
                handledDelete(cell);
            }}>
                <SVGIconDelete />
            </a>
        </div>
    };

    const supplierLink = useMemo(() => (cell) => {
        return <a href='' onClick={e => {
            handleLinkClick(e, cell);
        }
        } >{cell.value}</a>
    }, [handleLinkClick])

    function closePartWindow(deletedParts) {
        setShowParts(false);
        if (deletedParts) {
            loadCampaing()
        }
    }

    const sortByResponsedOn = (rowA, rowB, id, desc) => {
        const date1 = new Date(rowA.values[id] ? rowA.values[id] : 0).getTime();
        const date2 = new Date(rowB.values[id] ? rowB.values[id] : 0).getTime();
        if(date1  > date2)  return 1;
        else if(date2 > date1)  return -1;
    }

    const lockedCell = (cell) => {
        if (typeof cell.value === "boolean") {
            return cell.value ? "Yes" : "No";
        }

        if (typeof cell.value === "string") {
            return cell.value;
        }

        return "";
    }

    const columns = useMemo(
        () => {
            const baseColumns = [{
                Header: DETAILS_PAGE_TABLE_HEADERS.REQ_NO.headerName,
                accessor: DETAILS_PAGE_TABLE_HEADERS.REQ_NO.accessor,
                Cell: cell => supplierLink(cell)
            },
            {
                Header: DETAILS_PAGE_TABLE_HEADERS.SUPPLIER.headerName,
                accessor: DETAILS_PAGE_TABLE_HEADERS.SUPPLIER.accessor,
            },
            {
                Header: DETAILS_PAGE_TABLE_HEADERS.STATUS.headerName,
                accessor: DETAILS_PAGE_TABLE_HEADERS.STATUS.accessor,
            },
                        {
                Header: DETAILS_PAGE_TABLE_HEADERS.LOCKED.headerName,
                accessor: DETAILS_PAGE_TABLE_HEADERS.LOCKED.accessor,
                Cell: cell => lockedCell(cell)
            },
            {
                Header: campaign.isNonDeere? DETAILS_PAGE_TABLE_HEADERS.COMPANY_CONTACT.headerName: DETAILS_PAGE_TABLE_HEADERS.DEERE_CONTACT.headerName,
                accessor: campaign.isNonDeere ? DETAILS_PAGE_TABLE_HEADERS.COMPANY_CONTACT.accessor : DETAILS_PAGE_TABLE_HEADERS.DEERE_CONTACT.accessor,
                Cell: cell => popOverContacts(cell)
            },
            ...(!campaign.isNonDeere ? [{
                Header: DETAILS_PAGE_TABLE_HEADERS.DEERE_EMAIL.headerName,
                accessor: DETAILS_PAGE_TABLE_HEADERS.DEERE_EMAIL.accessor,
                Cell: cell => popOverContacts(cell, true)
            }] : []),
            {
                Header: DETAILS_PAGE_TABLE_HEADERS.SUPP_CONTACT.headerName,
                accessor: campaign.isNonDeere ? DETAILS_PAGE_TABLE_HEADERS.SUPP_CONTACT_ND.accessor : DETAILS_PAGE_TABLE_HEADERS.SUPP_CONTACT.accessor,
                Cell: cell => popOverContacts(cell)
            },
            ...(!campaign.isNonDeere ? [{
                Header: DETAILS_PAGE_TABLE_HEADERS.SUPP_EMAIL.headerName,
                accessor: DETAILS_PAGE_TABLE_HEADERS.SUPP_EMAIL.accessor,
                 Cell: cell => popOverContacts(cell, true)
            }] : []),
            {
                Header: DETAILS_PAGE_TABLE_HEADERS.SUBMITTED_BY.headerName,
                accessor: DETAILS_PAGE_TABLE_HEADERS.SUBMITTED_BY.accessor,
            },
            {
                Header: DETAILS_PAGE_TABLE_HEADERS.RESPONDED_ON.headerName,
                accessor: DETAILS_PAGE_TABLE_HEADERS.RESPONDED_ON.accessor,
                sortType: sortByResponsedOn
            }
            ];

            if (campaign.templateType === CRS_SURVEY_TEMPLATES.PART 
                || campaign.surveyCode === CRS_SURVEY_CODES.CM
                || campaign.surveyCode === CRS_SURVEY_CODES.EM
                || campaign.surveyCode === CRS_SURVEY_CODES.TPS
                || campaign.surveyCode === CRS_SURVEY_CODES.TPSMEX
                || campaign.surveyCode === CRS_SURVEY_CODES.COO
            ) {
                baseColumns.push({
                    Header: campaign.surveyCode === EWDC ? EMP_REQ : DETAILS_PAGE_TABLE_HEADERS.PART_REQ.headerName,
                    accessor: DETAILS_PAGE_TABLE_HEADERS.PART_REQ.accessor,
                    sortable: false,
                    Cell: cell => popUpPartsLink(cell)
                });
                baseColumns.push({
                    Header: campaign.surveyCode === EWDC ? EMP_DEC : DETAILS_PAGE_TABLE_HEADERS.PART_DEC.headerName,
                    accessor: DETAILS_PAGE_TABLE_HEADERS.PART_DEC.accessor,
                });
            }
            return baseColumns;
        },
        [campaign, supplierLink, popoverContacts]
    )

    const attachmentIconCell = (cell) => {
        if (!cell.row.original.hasAttachments) return null;
        return (
            <Tooltip title="Attachments">
                <IconButton
                    variant="secondary"
                    size="sm"
                    onClick={() => {
                        setSelectedAttachmentRow(cell.row.original);
                        setShowAttachmentModal(true);
                    }}
                >
                    <AttachFileIcon />
                </IconButton>
            </Tooltip>
        );
    };

    columns.push({
        Header: DETAILS_PAGE_TABLE_HEADERS.ATTACHMENTS.headerName,
        accessor: DETAILS_PAGE_TABLE_HEADERS.ATTACHMENTS.accessor,
        Cell: cell => attachmentIconCell(cell)
    });

    const rolAccess = (campaign && campaign.adminRole) ? userInfo.roles.includes(campaign.adminRole) : '';
    if (rolAccess && campaign && campaign.status !== SCBM_STATES_CAMPAIGN.CLOSED) {
        columns.push({
            Header: DETAILS_PAGE_TABLE_HEADERS.DELETE_ICON.headerName,
            accessor: DETAILS_PAGE_TABLE_HEADERS.DELETE_ICON.accessor,
            Cell: cell => iconDelete(cell)
        });

        columns.push({
            Header: DETAILS_PAGE_TABLE_HEADERS.SEND_EMAIL.headerName,
            accessor: DETAILS_PAGE_TABLE_HEADERS.SEND_EMAIL.accessor,
            Cell: cell => sendNotifyEmail(cell)
        });
        
        if( campaign.templateType === CRS_SURVEY_TEMPLATES.PART && campaign.lockCompletedRequest){
            columns.push({
                Header: DETAILS_PAGE_TABLE_HEADERS.UNLOCK.headerName,
                accessor: DETAILS_PAGE_TABLE_HEADERS.UNLOCK.accessor,
                Cell: cell => unlockAssignment(cell)
            });
        }else{
            columns.push({
                Header: DETAILS_PAGE_TABLE_HEADERS.REOPEN.headerName,
                accessor: DETAILS_PAGE_TABLE_HEADERS.REOPEN.accessor,
                Cell: cell => reopenAssignment(cell)
            });            
        }
    }

    function removeResponseOn(res) {
        try {
            if (res === undefined || res === null) {
                return []
            }

            if (Array.isArray(res)) {
                res.forEach((e) => {

                    e.responseon = e.status !== CRS_REQUEST_STATUS_OBJ.COMPLETE ? '' : e.responseon
                    e.responseByName = e.status !== CRS_REQUEST_STATUS_OBJ.COMPLETE ? '' : e.responseByName
                    e.status = e && campaign ? getRequestStatusWhenCampaignClosed(e.status, campaign.status) : "";
                })

                return res
            }
        } catch (error) {
            console.log(error)
        }
        return []
    }

    const parseDateAcrossTimeZones = (dateString) => {
        const parts = dateString.split('-');
        const year = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        const day = parseInt(parts[2], 10);
        let parsedDate =  new Date(Date.UTC(year, month, day));
        const utcYear = parsedDate.getUTCFullYear();
        const utcMonth = parsedDate.getUTCMonth();
        const utcDate = parsedDate.getUTCDate();
        const utcDateObject = new Date(utcYear, utcMonth, utcDate);
        return utcDateObject;
    };
        /* show reminder dates */
        let reminderDates = [];
        let initialNotification = ""
        if(campaign.startDate){
            initialNotification = parseDateAcrossTimeZones(campaign.startDate);
            initialNotification = ((Number(initialNotification.getMonth()) + 1) + "/" + initialNotification.getDate() + "/" + initialNotification.getFullYear());
            const isOpenEndedCampaign = campaign.endDate && new Date(campaign.endDate).getFullYear() === 9999;
            if(isOpenEndedCampaign){
                // Open-ended: reminders go out every Monday while open; list past Mondays up to today (or the close date).
                let cursor = parseDateAcrossTimeZones(campaign.startDate);
                cursor = new Date(cursor.setDate(cursor.getDate() + (((8 - cursor.getDay()) % 7) || 7)));
                const upperBound = campaign.status === SCBM_STATES_CAMPAIGN.CLOSED && campaign.lastUpdatedTs
                    ? new Date(campaign.lastUpdatedTs)
                    : new Date();
                while(cursor.getTime() <= upperBound.getTime()){
                    reminderDates.push((Number(cursor.getMonth()) + 1) + "/" + cursor.getDate() + "/" + cursor.getFullYear());
                    cursor = new Date(cursor.setDate(cursor.getDate() + 7));
                }
            } else {
            let startDate= parseDateAcrossTimeZones(campaign.startDate);
            let daysUntilFirstRem = Number(campaign?.notificationConfig?.daysFirstRem);
            let dateAfter_DaysUntilFirstRem = new Date(startDate.setDate(startDate.getDate() + daysUntilFirstRem));
            let dateAfter_DaysUntilFirstRem_Day = dateAfter_DaysUntilFirstRem.getDay();
            let daySelected = DAYS_OF_THE_WEEK.indexOf(campaign?.notificationConfig?.remainderDay)+1;
            let dayDifference = 0;
            if(daySelected > dateAfter_DaysUntilFirstRem_Day){
                dayDifference = daySelected - dateAfter_DaysUntilFirstRem_Day;
            }else{
                dayDifference = 7 - (dateAfter_DaysUntilFirstRem_Day - daySelected);
            }
            let firstRem = dateAfter_DaysUntilFirstRem;
            firstRem = new Date(firstRem.setDate(firstRem.getDate() + dayDifference));
    
            let endDate = new Date(campaign.endDate);
            if(!campaign.endDate || endDate.getTime() > firstRem.getTime()){
                reminderDates.push((Number(firstRem.getMonth()) + 1) + "/" +  firstRem.getDate() + "/" + firstRem.getFullYear());
                let noOfReminders = Number(campaign?.notificationConfig?.numberRemainders);
                let temp = new Date(firstRem);
                for(let i=1; i<noOfReminders; i++){
                    temp = new Date(temp.setDate(temp.getDate() + 7));
                    if(!campaign.endDate || endDate.getTime() > temp.getTime()){
                        reminderDates.push((Number(temp.getMonth()) + 1) + "/" + temp.getDate() + "/" + temp.getFullYear());
                    }
                    else{
                        break;
                    }
                }
            }
            }
        }

    return (
        <>
            {campaign.notificationConfig && 
                <Accordion variant="elevated" className='mb-3'>
                    <AccordionItem  >
                        <AccordionSummary rightAligned>
                            <AccordionTitle className='fw-bold'>{"Notification Dates"}</AccordionTitle>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Form.Row>
                                <Form.Group as={Col}>
                                    <Form.Label className="uxf-label">  {"Initial Notification:"} </Form.Label>
                                        <ul style={{ marginBottom: "0" }}>{campaign.startDate?initialNotification: ''}</ul>
                                </Form.Group>
                                <Form.Group as={Col}>
                                    <Form.Label className="uxf-label">  {"Reminder Dates:"} </Form.Label>
                                        {reminderDates.map((date, index)=>
                                            <ul style={{ marginBottom: "0" }}>{campaign.startDate?date: ''}</ul>
                                        )}
                                </Form.Group>
                            </Form.Row>
                        </AccordionDetails>
                    </AccordionItem>
                </Accordion>
            }
            <Card>
                <h4 className='pl-4 pt-4 fw-bold'>{'Responses'}</h4>
                <Card.Body>
                    <Alert accessibilityLabel="Danger:" variant="danger" aria-atomic="true" show={showError}>
                        <h5 className="uxf-alert-title">Something wrong happened</h5>
                    </Alert>
                    <DataTable data={data} columns={columns} />
                </Card.Body>
                <ModalGeneric showModal={showModal}
                    setShowModal={setShowModal}
                    labelBtnPrimary={t('t2_remove')}
                    labelBtnSecondary={t('btn_cancel')}
                    handleSubmit={handleSubmit}
                    msgModal={t('modal_generic_msg')}
                    titleModal={t('t2_remove')}
                />
                <ModalGeneric showModal={showReopenModal}
                    setShowModal={setShowReopenModal}
                    labelBtnPrimary={t('t2_reopen')}
                    labelBtnSecondary={t('btn_cancel')}
                    handleSubmit={reopeningAssignment}
                    msgModal={t('modal_reopen_msg')}
                    titleModal={t('t2_reopen')}
                />
                <ModalGeneric showModal={showUnlockModal}
                    setShowModal={setShowUnlockModal}
                    labelBtnPrimary={t('t2_unlock')}
                    labelBtnSecondary={t('btn_cancel')}
                    handleSubmit={unlockingAssignment}
                    msgModal={t('modal_unlock_msg')}
                    titleModal={t('t2_unlock')}
                />
                <ModalContactUpdate
                    showModal={showContactUpdateModal}
                    setShowModal={setShowContactUpdateModal}
                    labelBtnPrimary={t("btn_save_survey")}
                    labelBtnSecondary={t("btn_cancel")}
                    handleSubmit={() => { setShowContactUpdateModal(false) }}
                    dataModal={contactUpdateRow}
                    titleModal={t("lbl_add_contact")}
                    loadCampaing={loadCampaing}
                    campaign= {campaign}
                />
                <ModalAttachments
                    showModal={showAttachmentModal}
                    setShowModal={setShowAttachmentModal}
                    surveyCode={campaign.surveyCode}
                    assignmentId={selectedAttachmentRow?.assignmentid}
                    token={accessToken}
                    isAuthMethodOkta={authState?.isAuthenticated}
                />
            </Card>
            <Snackbar
                open={openSnackbar}
                autoHideDuration={3000} // Closes after 3 seconds
                onClose={() => { setOpenSnackbar(false);
                    loadCampaing();

                }}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                >
                <MuiAlert
                    onClose={() => setOpenSnackbar(false)}
                    severity={snackbarSeverity}
                    sx={{ width: "100%" }}
                >
                    {snackbarMessage}
                </MuiAlert>
            </Snackbar>
            {
                (campaign.templateType === CRS_SURVEY_TEMPLATES.PART || campaign.surveyCode === CRS_SURVEY_CODES.CM || campaign.surveyCode === CRS_SURVEY_CODES.EM ||
                campaign.surveyCode === CRS_SURVEY_CODES.TPS || campaign.surveyCode === CRS_SURVEY_CODES.COO || campaign.surveyCode === CRS_SURVEY_CODES.TPSMEX)
                && showParts 
                ? 
                    <PartPopUp
                    show={showParts}
                    handleClose={closePartWindow}
                    requestNumber={rnSelected}
                    campaign={campaign}
                    loadCampaing={loadCampaing}
                    partFunc={getAllPartsRequestedByAssignment}
                    partDeleteFunc={removeRequestedPartFromAssignment}
                    showDeletButton={showDeleteParts}
                    additionalColumns={additionalColumns}
                    ></PartPopUp>
                : 
                    null
            }
        </>
    )
}